module.exports = __webpack_public_path__ + "static/media/user.8725c157.png";